// extracted by mini-css-extract-plugin
export default {"container":"HW11_container__eHsL9","wrapper":"HW11_wrapper__fRdet","number":"HW11_number__G74VA"};